function UiDevelopment() {
    return (
        <div class="app-development uidevelopment_wrapper" style={{ marginTop: "5.2%" }}>
            <section class="banner_wrapper " >
                {/* <!-- id="module" --> */}
                <div id="element2"> </div>
                <div class="container">
                    <div class="Banner_content">
                        <div class="Bnr_left bnr-cmn">
                            <div class="hero_text">
                                <h1 data-aos="zoom-in"
                                    data-aos-duration="300"
                                    data-aos-easing="ease-in-sine">UI & UX Designing</h1>
                            </div>
                            {/* <!-- cd-intro --> */}
                            <p data-aos="fade-up"
                                data-aos-duration="1000"
                                data-aos-easing="ease-in-sine">We Design Visually Stunning & User-Friendly Customer Experience.
                            </p>
                        </div>
                    </div>
                </div>

            </section>
            {/* <!-- App content --> */}
            {/* <!-- end---here --> */}

            <section class="Our-Service_wrapper AppConten_wrp UIContent_Wrp">
                <div class="container">
                    <div class="Srv-heading">
                        <h2 data-aos="zoom-in"
                            data-aos-duration="300"
                            data-aos-easing="ease-in-sine">Our UI & UX Services</h2>
                        <p data-aos="fade-up"
                            data-aos-duration="1000"
                            data-aos-easing="ease-in-sine">The Design division at TechDH works as an independent wing with a dedicated team of User interface(UI) Designers, User Experience (UX) Designers, Graphic Designers, and Animators.
                        </p>
                    </div>
                    <div class="App_cnt Android_app UxDesign">
                        <div class="left_app1 left-cmn01" data-tilt data-tilt-glare data-tilt-max-glare="0.8">
                            <figure data-aos="fade-right"
                                data-aos-duration="300"
                                data-aos-easing="ease-in-sine">
                                <img src="image/ui.gif" alt="img" />
                            </figure>
                        </div>
                        <div class="right_app1 left-cmn01">
                            <h2 data-aos="fade-up"
                                data-aos-duration="300"
                                data-aos-easing="ease-in-sine">UI/UX for Mobile & Web</h2>
                            <p data-aos="fade-up"
                                data-aos-duration="1000"
                                data-aos-easing="ease-in-sine">We follow industry standards and create UI/UX based on design guidelines. UI/UX design services we offer include
                                <br />
                                <br />UI Design
                                <br />UX Design
                                <br />Prototyping
                                <br />Interaction Design
                                <br />Graphic Design
                            </p>
                            {/* <ul>
                                <li data-aos="fade-up"
                                    data-aos-duration="1000"
                                    data-aos-easing="ease-in-sine">UI&UX Design </li>
                                <li data-aos="fade-up"
                                    data-aos-duration="1200"
                                    data-aos-easing="ease-in-sine">Interaction Design
                                </li>
                                <li data-aos="fade-up"
                                    data-aos-duration="1300"
                                    data-aos-easing="ease-in-sine">Graphic Design</li>
                            </ul> */}
                        </div>
                    </div>
                </div>
            </section>


        </div>
    )
}

export default UiDevelopment